import React from 'react';
import { ReferencePage } from './ReferencePage';
import { WarehouseForm } from '../../components/WarehouseForm';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { TABLE_COLUMNS } from '../../constants/tables';
import { Warehouse } from '../../types';

export const WarehousesPage: React.FC = () => {
  const { t } = useLanguage();
  const { warehouses } = useData();

  return (
    <ReferencePage<Warehouse>
      title={t('references.warehouses')}
      items={warehouses.items}
      columns={TABLE_COLUMNS.WAREHOUSES}
      onAdd={warehouses.add}
      onEdit={warehouses.edit}
      onDelete={warehouses.remove}
      renderForm={({ theme, initialData, onSubmit, onCancel }) => (
        <WarehouseForm
          theme={theme}
          initialData={initialData}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      )}
    />
  );
};
